export enum ConfigurationEnum {
  HORARIO_DISPONIBILIDADE = "HORARIO_DISPONIBILIDADE",
}
